const TIMESHEETS_UI_SCHEMA = {
  table: {
    columnSections: [
      {
        key: 'employees',
        title: 'Employees',
      },
      {
        key: 'hours',
        title: 'Hours',
      },
      {
        key: 'details',
        title: 'Details',
      },
    ],
    items: [
      {
        property: 'fullLegalName',
        columnDescription: 'Legal name',
        columnHeader: 'legal name',
        activeByDefault: false,
        formula: 'data.user.fullLegalName',
        unit: 'none',
        sectionKey: 'employees',
      },
      {
        property: 'preferredName',
        activeByDefault: false,
        formula: 'data.user.fullname',
        unit: 'none',
        sectionKey: 'employees',
        if: 'false', // for mapping purposes but we don't need to ever show it on the columns picker etc.
      },
      {
        property: 'employeeId',
        columnDescription: 'Employee ID',
        columnHeader: 'employee id',
        activeByDefault: false,
        formula: 'data.user.employeeId',
        userLink: 'data.user.id',
        unit: 'none',
        sumUp: false,
        emptyValue: "''",
        includeForTotals: false,
        sectionKey: 'employees',
      },
      {
        property: 'position',
        columnDescription: 'Position',
        columnHeader: 'position',
        activeByDefault: true,
        formula: 'data.position',
        sumUp: false,
        unit: 'none',
        linkedPosition: true,
        includeForTotals: false,
        if: 'options.sortBy !== "position"',
        disabledDescription: 'Column unavailable when grouped by position.',
        emptyValue: "'-'",
        sectionKey: 'employees',
      },
      {
        property: 'location',
        columnDescription: 'Location',
        columnHeader: 'location',
        activeByDefault: true,
        formula: 'data.location',
        linkedLocation: true,
        sumUp: false,
        unit: 'none',
        includeForTotals: false,
        if: 'options.sortBy !== "location"',
        disabledDescription: 'Column unavailable when grouped by location.',
        emptyValue: "'-'",
        sectionKey: 'employees',
      },
      {
        property: 'groups',
        columnDescription: 'Groups',
        columnHeader: 'groups',
        activeByDefault: false,
        formula: 'data.user.groups',
        sumUp: false,
        unit: 'none',
        linkedGroup: true,
        includeForTotals: false,
        if: 'options.sortBy !== "group" && !!options.groups.length',
        disabledDescription:
          'Column unavailable when grouped by group or when there are no groups in the organisation',
        emptyValue: '""',
        sectionKey: 'employees',
      },
      {
        property: 'dtstart',
        columnDescription: 'Sch. shift start',
        columnHeader: 'shift start',
        activeByDefault: true,
        formula: 'data.dtstart',
        sumUp: false,
        unit: 'time',
        includeForTotals: false,
        emptyValue: "''",
        sectionKey: 'hours',
        showEmptyValueIfUnscheduled: true,
      },
      {
        property: 'clockedIn',
        columnDescription: 'Clocked in time',
        columnHeader: 'clocked in',
        activeByDefault: true,
        formula: 'data.clockedInArray',
        sumUp: false,
        unit: 'time',
        includeForTotals: false,
        emptyValue: "''",
        sectionKey: 'hours',
        isArray: true,
      },
      {
        property: 'dtend',
        columnDescription: 'Sch. shift end',
        columnHeader: 'shift end',
        activeByDefault: true,
        formula: 'data.dtend',
        sumUp: false,
        unit: 'time',
        includeForTotals: false,
        emptyValue: "''",
        sectionKey: 'hours',
        showEmptyValueIfUnscheduled: true,
      },
      {
        property: 'clockedOut',
        columnDescription: 'Clocked out time',
        columnHeader: 'clocked out',
        activeByDefault: true,
        formula: 'data.clockedOutArray',
        sumUp: false,
        unit: 'time',
        includeForTotals: false,
        emptyValue: "'-'",
        sectionKey: 'hours',
        isArray: true,
      },
      {
        property: 'breakType',
        columnDescription: 'Break type',
        columnHeader: 'break type',
        activeByDefault: true,
        formula: 'data.breakTypeArray',
        sumUp: false,
        unit: 'none',
        emptyValue: '""',
        includeForTotals: false,
        sectionKey: 'hours',
        isArray: true,
        hideWhenDisabled: true,
        if: 'orgSettings.shiftBreakType > 0 || options.timesheetsWithBreaksExistInView',
      },
      {
        property: 'breakStart',
        columnDescription: 'Break start',
        columnHeader: 'break start',
        activeByDefault: true,
        formula: 'data.breakStartArray',
        sumUp: false,
        unit: 'time',
        emptyValue: '"-"',
        includeForTotals: false,
        sectionKey: 'hours',
        isArray: true,
        hideWhenDisabled: true,
        if: 'orgSettings.shiftBreakType > 0 || options.timesheetsWithBreaksExistInView',
      },
      {
        property: 'breakEnd',
        columnDescription: 'Break end',
        columnHeader: 'break end',
        activeByDefault: true,
        formula: 'data.breakEndArray',
        sumUp: false,
        unit: 'minutes',
        emptyValue: '"-"',
        includeForTotals: false,
        sectionKey: 'hours',
        isArray: true,
        hideWhenDisabled: true,
        if: 'orgSettings.shiftBreakType > 0 || options.timesheetsWithBreaksExistInView',
      },
      {
        property: 'scheduledBreakDuration',
        columnDescription: 'Sch. break duration',
        columnHeader: 'sch. break duration',
        activeByDefault: true,
        formula: 'data.breakDuration || 0',
        sumUp: true,
        unit: 'minutes',
        emptyValue: 'options.isPastDtendWithNoClockIn ? "-" : ""',
        includeForTotals: true,
        sectionKey: 'hours',
        hideWhenDisabled: true,
        displayEmptyWhenZero: true,
        if: 'orgSettings.shiftBreakType > 0 || options.timesheetsWithBreaksExistInView',
      },
      {
        property: 'break',
        columnDescription: 'Break duration',
        columnHeader: 'break duration',
        activeByDefault: true,
        formula: 'data.actualBreakDuration || 0',
        sumUp: true,
        unit: 'minutes',
        emptyValue: '""',
        includeForTotals: true,
        sectionKey: 'hours',
        hideWhenDisabled: true,
        displayEmptyWhenZero: true,
        if: 'orgSettings.shiftBreakType > 0 || options.timesheetsWithBreaksExistInView',
      },
      {
        property: 'scheduled',
        columnDescription: 'Scheduled duration',
        columnHeader: 'scheduled',
        activeByDefault: true,
        formula: 'data.paidDurationMinutes || 0',
        sumUp: true,
        unit: 'minutes',
        emptyValue: "''",
        includeForTotals: true,
        sectionKey: 'hours',
        displayEmptyWhenZero: true,
      },
      {
        property: 'actual',
        columnDescription: 'Actual duration',
        columnHeader: 'actual',
        activeByDefault: true,
        formula: 'data.actualDuration || 0',
        sumUp: true,
        unit: 'minutes',
        emptyValue: '""',
        includeForTotals: true,
        sectionKey: 'hours',
        displayEmptyWhenZero: true,
      },
      {
        property: 'difference',
        columnDescription: 'Duration difference',
        columnHeader: 'difference',
        activeByDefault: true,
        formula: 'data.actualDifference || 0',
        sumUp: true,
        delta: true,
        unit: 'minutes',
        emptyValue: 'options.isPastDtendWithNoClockIn ? "-" : ""',
        includeForTotals: true,
        sectionKey: 'hours',
        displayEmptyWhenZero: true,
      },
      {
        property: 'date',
        columnDescription: 'Date',
        columnHeader: 'date',
        activeByDefault: true,
        formula: 'data.dtstart',
        sumUp: false,
        unit: 'date:no-year-if-current',
        includeForTotals: false,
        emptyValue: "'-'",
        sectionKey: 'details',
        if: 'options.sortBy !== "date"',
      },
      {
        property: 'tags',
        columnDescription: 'tags',
        columnHeader: 'tags',
        activeByDefault: false,
        formula: 'data.tags',
        sumUp: false,
        unit: 'none',
        linkedTags: true,
        includeForTotals: false,
        if: '!!options.tags.length',
        disabledDescription: 'Column available when you have at least one tag',
        emptyValue: "''",
        sectionKey: 'details',
      },
      {
        property: 'status',
        columnDescription: 'Status',
        columnHeader: 'status',
        activeByDefault: true,
        formula: 'data.timesheetStatus',
        sumUp: false,
        unit: 'none', // @note: previously we used "minutes" here - seems like it was a mistake.
        emptyValue: '""',
        includeForTotals: false,
        sectionKey: 'details',
      },
      {
        property: 'isAutoClockOut',
        columnDescription: 'Auto clock-out',
        columnHeader: 'Auto clock-out',
        activeByDefault: true,
        formula: '""',
        hideWhenDisabled: true,
        sumUp: false,
        unit: 'none',
        includeForTotals: false,
        sectionKey: 'details',
      },
      {
        property: 'clockInDistanceFromLocation',
        columnDescription: 'Clock in distance',
        columnHeader: 'clock in dist.',
        activeByDefault: true,
        formula: 'data.timesheetProjections',
        disabledDescription:
          'Geofencing needs to be enabled for this column. Enable it in settings.',
        if: 'orgSettings.clockInGeoRequired',
        sumUp: false,
        unit: 'none',
        emptyValue: 'options.isPastDtendWithNoClockIn ? "-" : ""',
        includeForTotals: false,
        sectionKey: 'details',
      },
      {
        property: 'clockOutDistanceFromLocation',
        columnDescription: 'Clock out distance',
        columnHeader: 'clock out dist.',
        activeByDefault: true,
        formula: 'data.timesheetProjections',
        disabledDescription:
          'Geofencing needs to be enabled for this column. Enable it in settings.',
        if: 'orgSettings.clockInGeoRequired',
        sumUp: false,
        unit: 'none',
        emptyValue: 'options.isPastDtendWithNoClockIn ? "-" : ""',
        includeForTotals: false,
        sectionKey: 'details',
      },
      {
        property: 'source',
        columnDescription: 'Source',
        columnHeader: 'Source',
        activeByDefault: true,
        formula:
          'data.fromIntegration ? (data.fromIntegration[0].toUpperCase() + data.fromIntegration.slice(1)) : "Sling"',
        if: 'options.showShiftsSource',
        hideWhenDisabled: true,
        sumUp: false,
        unit: 'none',
        includeForTotals: false,
        sectionKey: 'details',
      },
    ],
  },
};

export default TIMESHEETS_UI_SCHEMA;
